<template>
  <v-dialog
    v-model="dialog"
    @keydown.esc="cancel"
    :max-width="options.width"
    :persistent="persistent || disableAutomaticDismiss"
    lazy>
    <v-toolbar dark :color="options.color" dense>
      <v-toolbar-title v-text="title"></v-toolbar-title>
    </v-toolbar>
    <slot v-bind="{ cancel, agree }">
      <v-card tile>
        <v-card-text v-if="text" v-html="text"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="cancelColor" flat="flat" :disabled="loading"
                 @click="cancel">
            {{ cancelText || $t('message.common.cancel') }}
          </v-btn>
          <v-btn :color="acceptColor" flat="flat" :loading="loading" :disabled="loading"
                 @click="disableAutomaticDismiss ? resolveAndWait() : agree()">
            {{ acceptText || $t('message.common.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </slot>
  </v-dialog>
</template>

<script>
/**
 * Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <nx-dialog-confirm ref="confirm"></confirm>
 *
 * Open it:
 * const agree = await this.$refs.confirm.open();
 */
export default {
  name: 'nx-dialog-confirm',
  props: {
    title: {
      type: String,
      default: 'Confirm',
    },
    text: {
      type: String,
    },
    acceptColor: {
      type: String,
      default: 'accent',
    },
    acceptText: {
      type: String,
      default: null,
    },
    cancelColor: {
      type: String,
      default: 'accent',
    },
    cancelText: {
      type: String,
      default: null,
    },
    width: {
      type: String,
    },
    disableAutomaticDismiss: {
      type: Boolean,
    },
    persistent: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      loading: false,
      options: {
        color: 'nx-primary--darken-3',
        width: this.width || 400,
      },
    };
  },
  methods: {
    open(options) {
      this.dialog = true;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    resolveAndWait() {
      this.resolve(true);
      this.loading = true;
    },
    agree() {
      this.resolve(true);
      this.dismiss();
    },
    cancel() {
      this.resolve(false);
      this.dismiss();
    },
    dismiss() {
      this.dialog = false;
      this.loading = false;
    },
  },
};
</script>
